export default __webpack_public_path__ + "69baaefba18c7666f01f73f2f6ab034a.jpg";